import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AccountTab, RoutePath, generateRoutePath } from '../../app/router/config';
import Layout from '../../layout';
export default function Root() {
    var navigate = useNavigate();
    useEffect(function () {
        navigate(generateRoutePath(RoutePath.ACCOUNT, { tab: AccountTab.OVERVIEW }));
    });
    return (_jsx(Layout, { children: _jsx(_Fragment, {}) }));
}
